import { inflectNoun } from '@monoimin/utils/helpers';

import { objectsDeclensions } from '@monoimin/intl';

import type { EnOrRuLocale } from '@monoimin/sb-types';

export const defineObjectsTotalCount = (
  count: number | undefined,
  locale: EnOrRuLocale
) => {
  if (typeof count !== 'number') {
    return '';
  }

  const objectKey = inflectNoun(
    Number(count),
    'oneObject',
    'twoObjects',
    'fiveObjects'
  );

  return `${count} ${objectsDeclensions[locale][objectKey]}`;
};

export default defineObjectsTotalCount;
